// Grayscales
export const gray05 = '#E7E6E8'
export const gray60 = '#787878'
export const gray80 = '#313131'
export const gray100 = '#181818'
export const white = '#FFFFFF'
export const black = '#000000'
// Primary
export const primary100 = '#5D5FEF'
export const primary05 = '#CECFFA'

export const darkBackground = '#161616'
export const link = '#bac0c2'

// Account sign-up palette (dark mobile card)
export const pageBackground = '#909090'
export const sheetBackground = '#272727'
export const fieldBackground = '#3A3A3A'
export const disabledBackground = '#353537'
export const disabledText = '#717173'
export const offWhite = '#F7FBFC'
export const mutedText = '#A3A3A3'
export const placeholderText = '#999999'
export const accentRed = '#F9423A'
export const linkBlue = '#79C3FE'
